export const profile = {
  name: "Faiz Shaikh.",
  nameJa: "ファイズ・シェイク",
  roles: ["engineer", "developer"],
  tagline:
    "I love crafting products that tackle real issues, building websites and apps with intuitive user experiences and efficient code.",
  resumeUrl:
    "https://drive.google.com/file/d/1EvzkKkQJnW7rtqYBEhTd7V3MIRupmYVv/view?usp=drive_link",
  available: true,
};

export const skills = [
  // { name: "HTML", image: "/logos/html.svg" },
  // { name: "CSS", image: "/logos/css.svg" },
  { name: "JavaScript", image: "/logos/javascript.svg" },
  { name: "TypeScript", image: "/logos/typescript.svg" },
  { name: "React", image: "/logos/react.svg" },
  { name: "Next.js", image: "/logos/nextjs.svg" },
  // { name: "Redux", image: "/logos/redux.svg" },
  { name: "Tailwind", image: "/logos/tailwindcss.svg" },
  { name: "GitHub", image: "/logos/github.svg" },
  // { name: "Git", image: "/logos/git.svg" },
  // { name: "Node.js", image: "/logos/nodejs.svg" },
  // { name: "Express", image: "/logos/expressjs.svg" },
  // { name: "MongoDB", image: "/logos/mongodb.svg" },
  { name: "Postman", image: "/logos/postman.svg" },
  // { name: "Appwrite", image: "/logos/appwrite.svg" },
  // { name: "Docker", image: "/logos/docker.svg" },
];

export const experience = [
  {
    company: "Fans Plug (Plug Media Holdings LLC)",
    role: "Frontend Engineer",
    period: "November 2025 – Present",
  },
  {
    company: "Freelance",
    role: "Frontend Developer",
    period: "January 2025 – October 2025",
  },
  {
    company: "Navrachana University",
    role: "Teaching Assistant",
    period: "January 2024 – December 2024",
  },
];

export const socials = [
  { name: "Twitter", link: "https://x.com/faizxtwt", icon: "twitter" },
  { name: "GitHub", link: "https://github.com/faizshaikh17", icon: "github" },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/faizshaikh17/",
    icon: "linkedin",
  },
];

// Single source of truth for both the projects list and the detail page.
export const projects = [
  {
    slug: "ossean",
    name: "Ossean",
    summary: "Discover open source projects in seconds.",
    description:
      "Discover the best open source projects in seconds. Free OSS discovery platform for developers. Browse GitHub repositories & trending projects in seconds not minutes.",
    tech: ["Next.js", "React", "TypeScript", "PostgreSQL", "Claude"],
    image: "/images/ossean.png",
    live: "https://ossean.in",
    github: "https://github.com/faizshaikh17/ossean",
  },
  {
    slug: "hicred",
    name: "Hicred",
    summary:
      "Modern credit card data with integrated AI search.",
    description:
      "Scraped modern credit card data with integrated AI searching features.",
    tech: ["Next.js", "React", "TypeScript", "Tailwind CSS", "Gemini"],
    image: "/images/hicred.png",
    live: "https://hicred.vercel.app/",
    github: "https://github.com/faizshaikh17/hicred",
  },
  // {
  //   slug: "clipe",
  //   name: "Clipe",
  //   summary: "Turn code snippets into share-worthy art.",
  //   description:
  //     "Clipe. is your go-to tool for turning code into share-worthy art. It transforms your code snippets into beautifully styled visuals with gradient backgrounds and multiple UI themes, perfect for social media, blogs, or developer portfolios. With a slick, responsive interface and vibrant customization options, Clipe. makes it easy to showcase your code in style. Plus, with the built-in export button, you can instantly download your snippet as a high-quality PNG image.",
  //   tech: ["React", "JavaScript", "Tailwind CSS", "Grok AI"],
  //   image: "/images/Clip.png",
  //   live: "https://clipe.vercel.app/",
  //   github: "https://github.com/faizshaikh17/clip",
  // },
  {
    slug: "thedailyhacker",
    name: "TheDailyHacker",
    summary: "A sleek UI reimagination of Hacker News.",
    description:
      "TheDailyHacker is a sleek and intuitive UI reimagination of Hacker News, designed to immerse users in the dynamic world of technology. It curates and showcases a diverse array of stories, discussions, and insights, delving deep into the latest trends, innovations, and ideas shaping the tech landscape. With a user-friendly interface, TheDailyHacker delivers a seamless and engaging experience for tech enthusiasts, developers, and curious minds alike.",
    tech: ["React", "JavaScript", "Tailwind CSS", "Grok AI"],
    image: "/images/TheDailyHacker.png",
    live: "https://thedailyhacker.vercel.app/",
    github: "https://github.com/faizshaikh17/thedailyhacker",
  },
  {
    slug: "lofi.station",
    name: "Lofi.Station",
    summary: "Your 24/7 cozy lofi radio companion.",
    description:
      "Lofi Station is your 24/7 cozy companion, a soothing online lofi radio web application crafted with love.",
    tech: ["React", "JavaScript", "Redux", "Tailwind CSS", "Grok AI"],
    image: "/images/Lofi.Station.png",
    live: "https://lofistation.vercel.app/",
    github: "https://github.com/faizshaikh17/LoFi.Station",
  },
  // {
  //   slug: "jusblog",
  //   name: "Jusblog",
  //   summary: "A minimalist, distraction-free blog platform.",
  //   description:
  //     "Jusblog is a minimalist and distraction-free blog platform designed for developers, writers, and anyone looking to share their thoughts and ideas with the world. Leveraging Markdown (via a rich text editor) for content creation, Jusblog offers a clean, easy-to-use interface perfect for personal blogs, technical documentation, or simply sharing your perspectives.",
  //   tech: ["React", "JavaScript", "Redux", "Tailwind CSS", "Grok AI", "Appwrite"],
  //   image: "/images/Jusblog.png",
  //   live: "https://jusblog.vercel.app/",
  //   github: "https://github.com/faizshaikh17/Jusblog",
  // },
];

export const getProjectBySlug = (slug) =>
  projects.find((project) => project.slug === slug?.toLowerCase());
